import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserIdService } from '../../../../../core/auth';
import { CmsMailFormConnector } from '../connectors';

@Injectable({ providedIn: 'root' })
export class CmsMailFormService {
  constructor(private cmsMailFormConnector: CmsMailFormConnector, private userIdService: UserIdService) {}

  postCmsMailForm(fieldsJson: string, recaptchaKey: string, filesFormData: FormData): Observable<any> {
    return this.userIdService
      .takeUserId()
      .pipe(switchMap((userId) => this.cmsMailFormConnector.postCmsMailForm(userId, recaptchaKey, fieldsJson, filesFormData)));
  }
}
